<template>
  <div class="wrapper h-100">
    <navbar/>
    <div class="container-fluid h-100">
      <div class="row h-100">
        <sidebar v-if="user" />
        
        <child/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Navbar from '~/components/Navbar'
import Sidebar from '~/components/Sidebar'

export default {
  name: 'MainLayout',
  middleware: 'auth',
  components: {
    Navbar,
    Sidebar,
  },
  computed: mapGetters({
    user: 'auth/user'
  }),
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/layouts/default.vue